var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 129.676,
    height: 263.243,
    viewBox: "0 0 129.676 263.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21667",
    "data-name": "Group 21667",
    transform: "translate(-3.702 -176.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50666",
    "data-name": "Path 50666",
    d: "M126.212,397.17a109.549,109.549,0,0,1-24.384-67.485L55.12,304.9l-19.2,23.548a119.729,119.729,0,0,1-1.108,15.439,120.541,120.541,0,0,1-7.661,28.792L11.49,397.747c6.918,4.915,29.664,19.753,61.71,18.209A98.845,98.845,0,0,0,126.212,397.17Z",
    transform: "translate(1.352 23.008)",
    fill: "#ce9a49",
    stroke: "#372514",
    strokeWidth: 0.429
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50667",
    "data-name": "Path 50667",
    d: "M25.06,369.262c1.155-2.958,2.286-6.152,3.335-9.57.907-2.923,1.674-5.74,2.322-8.415.354-1.626.79-3.783,1.214-6.317.177-1.037.79-4.832,1.273-9.935.236-2.569.46-5.692.566-9.24,12.976-.99,26.659-1.626,41-1.78,8.45-.094,16.665,0,24.632.224.047,3.441.082,6.895.13,10.336.471,3.347.955,6.682,1.426,10.03.177,1.167.448,2.746.872,4.608.283,1.237.53,2.169.955,3.76.471,1.768.872,3.229,1.308,4.667.613,2,.978,2.876,3.1,8.332.436,1.131,1.12,2.888,1.956,5.08a40.668,40.668,0,0,1-11.6-14.873,41.967,41.967,0,0,1-1.874-28.321,6.867,6.867,0,0,1-7.071,0S74.7,342.014,53.145,330c0,0-10.548,5.634-16.677.754q-1.768,12.87-3.547,25.728-1.467,2.9-3.371,6.07C28.054,365.031,26.533,367.259,25.06,369.262Z",
    transform: "translate(3.775 26.413)",
    fill: "#9b5843"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21625",
    "data-name": "Group 21625",
    transform: "translate(68.13 340.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50668",
    "data-name": "Path 50668",
    d: "M61.8,315.64a62.987,62.987,0,0,0,.306,21.344c.53,2.7,1.344,5.74,2.2,11.114.8,5.08,1.179,9.287,1.367,12.069a5.317,5.317,0,0,1-1-1.815,22.383,22.383,0,0,1-.684-4.5,16.029,16.029,0,0,0-1.2-5.009c-.153.118.2,3.76,2.11,17.455a27.714,27.714,0,0,1-1.061-3.618c-.365-1.6-.424-2.428-.719-3.771a21.542,21.542,0,0,0-1.5-4.526s.424,14.65,1.249,16.347c0,0-1.509-5.351-1.886-5.032s.024,20.837.684,22c-.955-5.657-1.744-11.668-2.263-17.985A214.551,214.551,0,0,1,61.8,315.64Z",
    transform: "translate(-58.351 -315.64)",
    fill: "#6d2610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50669",
    "data-name": "Path 50669",
    d: "M61.853,315.64a63,63,0,0,0,.731,22.3c.86,3.642,1.65,7.319,2.216,11.031.648,4.078,1.1,8.191,1.379,12.3a7.388,7.388,0,0,1-2.2-4.408,32.1,32.1,0,0,0-1.426-7.708.433.433,0,0,0,.707-.153c0,.153.012.542.047.837.707,6.883,1.815,13.907,2.746,20.778L64.5,366.472c-1.544-3.842-1.45-8.144-3.288-11.868l.955-.224a143.453,143.453,0,0,0,1.108,15.746l.118.377-.99.377c-.306-1.1-.636-2.192-1-3.253a10.5,10.5,0,0,0-.6-1.485c-.012-.035-.082-.071.047.012a.473.473,0,0,0,.507-.047.365.365,0,0,0,.071-.047.355.355,0,0,0,.083-.141c-.012.094-.024.236-.035.365-.177,6.506.012,13.165.448,19.67l.094.837a4.9,4.9,0,0,0,.118.672l-.884.318a208.6,208.6,0,0,1,.6-72.14Zm0,0a222.564,222.564,0,0,0,1.037,76.076c-.283-.8-1.85-4.031-1.827-4.785-.2-1.52-.33-4.479-.412-6.046-.153-5.056-.436-10.1-.153-15.156a.8.8,0,0,1,.236-.436.593.593,0,0,1,.648-.035.926.926,0,0,1,.318.342,32.213,32.213,0,0,1,1.744,5l-.99.377c-.071-.2-.141-.4-.2-.6-.955-6.07-.9-12.292-1.155-18.421l1.037,2.228c1.85,3.771,1.756,8.1,3.265,11.962l-.931.236c-.66-4.867-1.344-9.723-1.9-14.614a19.184,19.184,0,0,1-.189-2.958c.094-.224.106-.342.436-.4a.477.477,0,0,1,.4.177,16.087,16.087,0,0,1,1.143,4.514c.389,2.31.082,4.974,1.638,6.836l-.648.271a140.782,140.782,0,0,0-3.217-22.169,62.989,62.989,0,0,1-.283-22.393Z",
    transform: "translate(-58.401 -315.64)",
    fill: "#6d2610"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50670",
    "data-name": "Path 50670",
    d: "M103.639,218.936s13.365-12.175,28.8-15.746c0,0,1.7,2.145-.625,5.374s-11.4,17.843-12.4,20.165-4.938,7.967-4.938,13.707c0,0,1.214,11.691.6,13.506,0,0,2.428,2.216-3.206,14.2,0,0-2.227,4.467-1.768,12.693a116.164,116.164,0,0,1-.236,15.522c-.118,3.642-.236,18.81.118,19.871s4.29,18-4.95,27.885c0,0-1.591,3.571-8.733,2.357a6.412,6.412,0,0,1-3.547-2.994s-3.335,6.647-15.227,8.1a31.757,31.757,0,0,1-20.59-4.243S48.777,354.2,42.672,351.3s-8.9-11.279-8.9-11.279S30.768,330.3,31.287,324.3s1.45-9.523.519-12.729-1.756-14.485-1.237-17.066-1.45-17.172-2.581-17.69-3.312-7.036-1.556-13.141a12.716,12.716,0,0,1-.66-9.2c1.485-5.48-5.751-15.828-5.751-15.828s-1.237-14.791-13.035-17.9a27.558,27.558,0,0,0-2.9-1.344c-.519-.106-.519-5.174,10.548-3.936,0,0,7.555-1.556,17.49,9.417C32.112,224.864,100.421,223.485,103.639,218.936Z",
    transform: "translate(0 4.846)",
    fill: "#ce9a49",
    stroke: "#372514",
    strokeWidth: 0.429
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50671",
    "data-name": "Path 50671",
    d: "M4.321,215.461s11.456-.613,19.057,12.245c0,0,2.074,11.338,0,14.037l-3.394-5.292s-.955-6.765-2.44-8.545c0,0-3.052-5.527-4.42-6.034S11.44,219.6,6.949,218.56l-2.9-1.344Z",
    transform: "translate(0.024 7.037)",
    fill: "#9b5843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50672",
    "data-name": "Path 50672",
    d: "M116.033,203.19S106.6,206.914,99.286,224.6l-3.406,8.934",
    transform: "translate(16.421 4.846)",
    fill: "none",
    stroke: "#1d1d1b",
    strokeWidth: 0.429
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21626",
    "data-name": "Group 21626",
    transform: "translate(112.301 208.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50673",
    "data-name": "Path 50673",
    d: "M116.033,203.19S106.6,206.914,99.286,224.6l-3.406,8.934s14.06-16.547,15.345-18.574,3.229-5.021,3.229-5.021S118.155,205.9,116.033,203.19Z",
    transform: "translate(-95.88 -203.19)",
    fill: "#9b5843"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21627",
    "data-name": "Group 21627",
    transform: "translate(30.745 237.96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50674",
    "data-name": "Path 50674",
    d: "M26.68,240.8A19.014,19.014,0,0,1,40.222,230.03c3.265-.53,6.624-.2,9.888-.589a10.083,10.083,0,0,0,3.819-.86,10.249,10.249,0,0,1-3.783,1.108c-3.229.53-6.612.283-9.829.825A20.22,20.22,0,0,0,26.68,240.8Z",
    transform: "translate(-26.68 -228.58)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21628",
    "data-name": "Group 21628",
    transform: "translate(53.503 239.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50675",
    "data-name": "Path 50675",
    d: "M54.77,230.726a13.462,13.462,0,0,0-4.349-.636c-1.485-.047-2.935.577-4.431.4,2.876-.79,6.093-1.556,8.78.236Z",
    transform: "translate(-45.99 -229.63)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21629",
    "data-name": "Group 21629",
    transform: "translate(50.262 240.591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50676",
    "data-name": "Path 50676",
    d: "M51.125,232.648c-.731.13-1.344-.389-1.956-.6a9.937,9.937,0,0,0-1.909-.589c-1.32-.4-2.722-.059-4.019-.542,1.367.071,2.758-.306,4.125.059a8.258,8.258,0,0,1,1.968.743c.648.295,1.108.849,1.791.931Z",
    transform: "translate(-43.24 -230.813)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21630",
    "data-name": "Group 21630",
    transform: "translate(42.33 237.117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50677",
    "data-name": "Path 50677",
    d: "M48.944,228.448a30.178,30.178,0,0,0-6.447.071,22.745,22.745,0,0,0-5.987,2.322,14.641,14.641,0,0,1,5.893-2.829,17.409,17.409,0,0,1,6.541.436Z",
    transform: "translate(-36.51 -227.865)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21631",
    "data-name": "Group 21631",
    transform: "translate(38.134 235.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50678",
    "data-name": "Path 50678",
    d: "M43.687,226.39c-4.231.813-7.555,3.913-10.737,6.647,2.557-3.159,6.47-6.588,10.737-6.647Z",
    transform: "translate(-32.95 -226.39)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21632",
    "data-name": "Group 21632",
    transform: "translate(80.845 245.484)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50679",
    "data-name": "Path 50679",
    d: "M103.486,242.549c-3.795-6.459-9.228-7.649-16.241-6.93-3.135.177-6.376.236-9.122,1.956-2.817,1.438-5.74,2.911-8.934,3.276a17,17,0,0,0,4.514-1.461c2.227-.908,4.184-2.275,6.388-3.241a28.547,28.547,0,0,1,7.13-1.025c7.119-.684,12.764.636,16.264,7.425Z",
    transform: "translate(-69.19 -234.964)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21633",
    "data-name": "Group 21633",
    transform: "translate(106.715 245.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50680",
    "data-name": "Path 50680",
    d: "M96.6,238.469c-.224-.4-.907-.837-1.237-1.19-.424-.377-.813-.837-1.226-1.179-.778-.766-2.051-.919-2.994-1.52a6.755,6.755,0,0,1,3.324,1.131,9.433,9.433,0,0,1,2.133,2.758Z",
    transform: "translate(-91.14 -234.58)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21634",
    "data-name": "Group 21634",
    transform: "translate(92.961 243.888)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50681",
    "data-name": "Path 50681",
    d: "M86.977,233.834c-2.64.012-4.95.955-7.507,1.45,2.286-1.143,4.95-2.133,7.507-1.45Z",
    transform: "translate(-79.47 -233.609)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21635",
    "data-name": "Group 21635",
    transform: "translate(99.467 247.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50682",
    "data-name": "Path 50682",
    d: "M98.343,242.385a10.763,10.763,0,0,0-9.558-5.032,18.791,18.791,0,0,0-3.795.342c4.75-1.8,11.291-.424,13.353,4.691Z",
    transform: "translate(-84.99 -236.94)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21636",
    "data-name": "Group 21636",
    transform: "translate(95.365 249.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50683",
    "data-name": "Path 50683",
    d: "M92.86,240.863a2.6,2.6,0,0,0-2.392-1.65c-2.027.024-4.278-.212-6.246.471a8.37,8.37,0,0,0-2.711,1.6,6.6,6.6,0,0,1,2.569-1.956,8.129,8.129,0,0,1,3.217-.6c1.874.071,5.115-.412,5.563,2.133Z",
    transform: "translate(-81.51 -238.73)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21638",
    "data-name": "Group 21638",
    transform: "translate(96.777 254.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50684",
    "data-name": "Path 50684",
    d: "M100.2,257.243s-1.815,4.526-5.41,4.007a29.068,29.068,0,0,1-7.9-2.864,5.356,5.356,0,0,1-2.628-1.733,7.293,7.293,0,0,1-1.214-5.94,9.839,9.839,0,0,1,4.4-6.176,12.471,12.471,0,0,1,8.615-1.685,15.176,15.176,0,0,1,5.032,1.5c-.035,1.509-.071,3.017-.106,4.537C102.149,250.607,100.2,257.243,100.2,257.243Z",
    transform: "translate(-82.676 -242.522)",
    fill: "#ce9a49"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21637",
    "data-name": "Group 21637"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50685",
    "data-name": "Path 50685",
    d: "M100.236,257.27c-.778,1.744-2.1,3.536-4.054,3.984-3.265.259-6.411-1.4-9.311-2.722-4.149-1.061-5.139-6.6-3.229-10.112a11.189,11.189,0,0,1,9.865-5.869,15.242,15.242,0,0,1,7.731,1.839l-.153,4.526c.931,2.569-.248,5.716-.849,8.356Zm0,0c.566-2.64,1.744-5.716.742-8.344,0-.012.047-4.537.047-4.549a18.329,18.329,0,0,0-7.519-1.438c-6.364-.13-12.846,6.836-9.487,13.035a5.255,5.255,0,0,0,2.958,2.31,28.873,28.873,0,0,0,7.26,2.84c2.734.79,5.009-1.52,6-3.854Z",
    transform: "translate(-82.708 -242.55)",
    fill: "#372514"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_50686",
    "data-name": "Path 50686",
    d: "M38.331,249.223c.318-.577-1.5-2.275-3.052-3.194a7.776,7.776,0,0,0-6-1.167,7.038,7.038,0,0,0-3.052,1.756,8.433,8.433,0,0,0-2.428,4.231c-.377,1.532-.742,3.052-1.12,4.585.625-.6,1.591-1.567,2.722-2.8,2.675-2.935,2.593-3.418,3.559-4.019C32.462,246.418,37.8,250.178,38.331,249.223Z",
    transform: "translate(3.35 12.25)",
    fill: "#9b5843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50687",
    "data-name": "Path 50687",
    d: "M23.091,255.744s4-8.167,7.519-8.167,7.814-.849,10.772,5.139-.978,11.409-.978,11.409-3.536,5.351-8.179,5.775a15.267,15.267,0,0,1-7.578-1.025S21.287,264.123,23.091,255.744Z",
    transform: "translate(3.329 12.765)",
    fill: "#efebe8",
    stroke: "#362513",
    strokeWidth: 0.429
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21640",
    "data-name": "Group 21640",
    transform: "translate(25.665 259.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50688",
    "data-name": "Path 50688",
    d: "M41.375,252.769a10.071,10.071,0,0,0-5.15-4.809,9.888,9.888,0,0,0-6.011-.354,7.436,7.436,0,0,0-1.226.519,12.627,12.627,0,0,0-5.9,7.661c-.271,1.45-.483,3.453-.483,3.453a49.931,49.931,0,0,0,7.9-2.781c1.85-.837,2.97-1.5,5.056-2.239A30.679,30.679,0,0,1,41.375,252.769Z",
    transform: "translate(-22.329 -247.2)",
    fill: "#ce9a49"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21639",
    "data-name": "Group 21639"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50689",
    "data-name": "Path 50689",
    d: "M41.416,252.784c-2.039-4.207-7.39-6.659-11.786-4.8-3.194,1.391-5.315,4.608-6.258,7.837l-.519,3.453-.271-.236c6.529-1.391,12.127-5.6,18.833-6.258Zm0,0c-6.682.955-12.2,5.186-18.727,6.682l-.318.082.047-.318.471-3.5a11.98,11.98,0,0,1,6.671-7.908c4.455-1.839,9.865.7,11.856,4.962Z",
    transform: "translate(-22.37 -247.215)",
    fill: "#372514"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21641",
    "data-name": "Group 21641",
    transform: "translate(25.936 252.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50690",
    "data-name": "Path 50690",
    d: "M22.6,255.852c.483-5.563,2.239-13.848,8.615-15.192-6.058,2.074-7.366,9.676-8.615,15.192Z",
    transform: "translate(-22.6 -240.66)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21642",
    "data-name": "Group 21642",
    transform: "translate(87.045 264.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50691",
    "data-name": "Path 50691",
    d: "M74.45,283.348a21.647,21.647,0,0,0,4.867-1.367c2.286-.742,4.6-2.18,4.785-4.8a1.778,1.778,0,0,0-.742-1.839c-1.414-1.037-2.18-2.793-2.935-4.337-2.711-6.388-2.77-13.341-3.347-20.118,1.344,6.553,1.615,13.542,4.278,19.706.719,1.473,1.308,2.994,2.652,4.042,1.65,1.261,1.037,3.724-.024,5.186-1.037,1.509-2.84,2.1-4.479,2.628a18.691,18.691,0,0,1-5.056.9Z",
    transform: "translate(-74.45 -250.89)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50692",
    "data-name": "Path 50692",
    d: "M81.24,274.2c-.024.306-.094,1.4.507,1.791.837.542,2.534-.566,3.265-1.85.189-.342.613-1.1.295-1.709-.365-.707-1.461-.743-1.791-.743a4.722,4.722,0,0,0-2.593.872,24.861,24.861,0,0,0-3.182,2.2c-.931.719-1.874,1.438-2.8,2.169-.012.012-.024.012-.035.024-1.072,1.355-5.516,1.685-8.05,2.263s-9.912-2.039-9.912-2.039-6.8-3.111-9.617-1.167-2.428,3.889-2.428,3.889A3.477,3.477,0,0,0,47.91,280a3.359,3.359,0,0,0,1.237-1.379,4.479,4.479,0,0,0,.589-1.839,29.372,29.372,0,0,1,10.69,3.394,8.58,8.58,0,0,1,3.547,2.652c1.45,1.886,1.52,3.795,2.051,9.817.118,1.391.33,3.63.6,6.447-.283-2.18-1.108-10.631,4.479-18,1.12-1.473,3.418-2.11,6.517-4.4C79.106,275.591,80.368,274.755,81.24,274.2Z",
    transform: "translate(7.314 17.078)",
    fill: "#362513"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21643",
    "data-name": "Group 21643",
    transform: "translate(47.435 258.243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50693",
    "data-name": "Path 50693",
    d: "M48.477,245.79c1.992,2.593,3.312,6.282,2.074,9.5-.919,3.1-1.992,6.459-3.088,9.487-1.461,4.149-3.618,8.085-4.785,12.351-.519,1.945-1.32,4.29-.825,6.223,1.367,3.677,6.058,4.738,9.558,3.854.495-.165,1.072-.413,1.237-.955-.118.566-.7.884-1.19,1.1a10.593,10.593,0,0,1-5.009.33,7.036,7.036,0,0,1-5.315-4.019,6.619,6.619,0,0,1-.106-3.512,50.817,50.817,0,0,1,2.946-9.605,117.766,117.766,0,0,0,4.856-12.316l1.1-3.135c1.32-3.123.259-6.517-1.45-9.3Z",
    transform: "translate(-40.841 -245.79)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21644",
    "data-name": "Group 21644",
    transform: "translate(85.203 251.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50694",
    "data-name": "Path 50694",
    d: "M74.717,240.4a7.457,7.457,0,0,1-.46,2.64,29.725,29.725,0,0,0-1.1,7.826c-.86-3.724.483-7.024,1.556-10.466Z",
    transform: "translate(-72.887 -240.4)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21645",
    "data-name": "Group 21645",
    transform: "translate(81.718 258.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50695",
    "data-name": "Path 50695",
    d: "M69.93,246.18a11.412,11.412,0,0,1,5.716,8.627,18.482,18.482,0,0,0-5.716-8.627Z",
    transform: "translate(-69.93 -246.18)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21646",
    "data-name": "Group 21646",
    transform: "translate(97.255 272.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50696",
    "data-name": "Path 50696",
    d: "M84.3,258.19c.024,2.334-.884,4.573-.66,6.906a16.272,16.272,0,0,0,1.732,6.635,12.233,12.233,0,0,1-2.239-6.624c-.165-2.392.778-4.608,1.167-6.918Z",
    transform: "translate(-83.114 -258.19)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21647",
    "data-name": "Group 21647",
    transform: "translate(43.155 277.041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50697",
    "data-name": "Path 50697",
    d: "M42.973,261.74a52.224,52.224,0,0,1-2.557,9.44c-1.131,3.041-2.758,6.011-3.206,9.181l.012-.413.035.413c-.177-3.206,1.674-6.341,2.687-9.358,1.155-3.029,2.121-6.14,3.029-9.264Z",
    transform: "translate(-37.21 -261.74)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21648",
    "data-name": "Group 21648",
    transform: "translate(72.396 281.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50698",
    "data-name": "Path 50698",
    d: "M63.033,265.49c.295,2.581-.106,5.15-.059,7.625-.035,2.546.754,4.915,1.32,7.39-3.147-4.549-2.475-9.971-1.261-15.015Z",
    transform: "translate(-62.021 -265.49)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50699",
    "data-name": "Path 50699",
    d: "M101.175,248.784a52.389,52.389,0,0,0-7.955-.012,50.817,50.817,0,0,0-10.171,1.8s-.825,5.3,3.83,6.765c0,0,5.881,2.876,7.9,2.864s4.219-.672,5.41-4.007a20.071,20.071,0,0,0,1.273-5.327,2.991,2.991,0,0,0-.012-1.379A2.96,2.96,0,0,0,101.175,248.784Z",
    transform: "translate(14.12 12.96)",
    fill: "#efebe8",
    stroke: "#362513",
    strokeWidth: 0.429
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50700",
    "data-name": "Path 50700",
    d: "M96.829,248.63c.035.153.742,3.217-1.249,5.091a5,5,0,0,1-3.076,1.249c-1.992.165-3.17-.318-3.854-1.049-.719-.754-.7-2.051-.778-3.866-.012-.212-.012-.389-.012-.507.566-.165,1.131-.318,1.685-.483Q93.187,248.836,96.829,248.63Z",
    transform: "translate(14.989 12.96)",
    fill: "#6d3c17",
    stroke: "#362513",
    strokeWidth: 0.429
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50701",
    "data-name": "Path 50701",
    d: "M94.38,248.89a2.632,2.632,0,1,1-5.08.33",
    transform: "translate(15.246 13.007)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50702",
    "data-name": "Path 50702",
    d: "M26.47,256.708c.766,3.017,2.958,5.08,5.292,5.174a4.8,4.8,0,0,0,2.958-.955c2.027-1.556,2.687-4.82,1.6-8.167-1.65.719-3.288,1.438-4.938,2.169Z",
    transform: "translate(4.027 13.698)",
    fill: "#6d3c17",
    stroke: "#362513",
    strokeWidth: 0.429
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50703",
    "data-name": "Path 50703",
    d: "M27.99,255.7a3.521,3.521,0,0,0,4.219,2.8,3.51,3.51,0,0,0,1.65-4.926",
    transform: "translate(4.299 13.844)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21649",
    "data-name": "Group 21649",
    transform: "translate(33.314 295.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50704",
    "data-name": "Path 50704",
    d: "M35.672,277.81c2.121,6.541-1.108,14.4-6.812,18.056,4.149-5.339,6.671-11.232,6.812-18.056Z",
    transform: "translate(-28.86 -277.81)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21650",
    "data-name": "Group 21650",
    transform: "translate(100.008 293.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50705",
    "data-name": "Path 50705",
    d: "M86.287,276.02a12.032,12.032,0,0,0,8.368,12.245c-6.046.684-11.3-6.883-8.368-12.245Z",
    transform: "translate(-85.45 -276.02)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21651",
    "data-name": "Group 21651",
    transform: "translate(46.313 302.852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50706",
    "data-name": "Path 50706",
    d: "M65.194,299.81a46.326,46.326,0,0,0,2.051,11.562,10.172,10.172,0,0,1-.035,6.046c-1.426,3.83-2.522,7.543-4.926,10.949-6.1,7.083-17.113,4.031-20.625-4.031-1.827-3.677-2.015-7.967-1.556-11.9.318-3.948.66-7.861,1.308-11.786a19.516,19.516,0,0,1,1.827-5.716c1.98-3.406,2.475-7.378,2.829-11.291.012,3.936-.389,8.026-2.157,11.6-1.662,3.512-1.78,7.5-2.11,11.4-.106,3.359-.825,8.4-.46,11.644.684,7.39,7.637,14.661,15.333,12.2,3.9-1.1,5.893-4.361,7.342-7.944.79-1.791,1.65-3.583,2.275-5.386a9.284,9.284,0,0,0,.236-5.575,43.6,43.6,0,0,1-1.332-11.762Z",
    transform: "translate(-39.89 -283.64)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21652",
    "data-name": "Group 21652",
    transform: "translate(73.644 298.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50707",
    "data-name": "Path 50707",
    d: "M63.08,315.9c3.489,6.2,11.432,13.459,18.9,13.011,5.08-.636,6.305-6.494,7.083-10.737,1.049-6.352,2.275-12.835,1.19-19.281-1.014-6.423-3.512-12.587-4.844-18.975,3.347,10.065,8.25,20.307,6.164,31.2-.542,4.078-.9,8.262-2.239,12.186-4.962,15.145-22.64,2.062-26.258-7.4Z",
    transform: "translate(-63.08 -279.92)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50708",
    "data-name": "Path 50708",
    d: "M64.051,310.45c-.943,2.687-1.662,4.844-2.145,6.317a20.01,20.01,0,0,1-1.438,3.654,14.97,14.97,0,0,1-2.829,3.712,25.69,25.69,0,0,1,3.795-1.886,19,19,0,0,1,6.364-1.615,14.384,14.384,0,0,1,8.462,2.569,52.021,52.021,0,0,1-12.21-12.752Z",
    transform: "translate(9.593 23.999)",
    fill: "#362513"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50709",
    "data-name": "Path 50709",
    d: "M33.58,286s7.873,3.948,8.085,26.093",
    transform: "translate(5.297 19.633)",
    fill: "none",
    stroke: "#362513",
    strokeWidth: 1.288
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50710",
    "data-name": "Path 50710",
    d: "M89.659,284.93s-3.359,4.632-2.487,19.352",
    transform: "translate(14.841 19.442)",
    fill: "none",
    stroke: "#362513",
    strokeWidth: 1.288
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1507",
    "data-name": "Ellipse 1507",
    cx: 0.448,
    cy: 0.448,
    r: 0.448,
    transform: "translate(92.466 321.721)",
    fill: "#362513"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1508",
    "data-name": "Ellipse 1508",
    cx: 0.448,
    cy: 0.448,
    r: 0.448,
    transform: "translate(92.466 325.127)",
    fill: "#362513"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1509",
    "data-name": "Ellipse 1509",
    cx: 0.448,
    cy: 0.448,
    r: 0.448,
    transform: "translate(92.466 329.593)",
    fill: "#362513"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1510",
    "data-name": "Ellipse 1510",
    cx: 0.448,
    cy: 0.448,
    r: 0.448,
    transform: "translate(53.255 337.82)",
    fill: "#362513"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1511",
    "data-name": "Ellipse 1511",
    cx: 0.448,
    cy: 0.448,
    r: 0.448,
    transform: "translate(55.235 331.727)",
    fill: "#362513"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1512",
    "data-name": "Ellipse 1512",
    cx: 0.448,
    cy: 0.448,
    r: 0.448,
    transform: "translate(56.025 327.448)",
    fill: "#362513"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21653",
    "data-name": "Group 21653",
    transform: "translate(92.914 310.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50711",
    "data-name": "Path 50711",
    d: "M79.43,301.866c4.219-6.14,10.937-11.939,18.716-12.116-7.154,2.228-13,7.5-18.716,12.116Z",
    transform: "translate(-79.43 -289.75)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21654",
    "data-name": "Group 21654",
    transform: "translate(93.362 320.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50712",
    "data-name": "Path 50712",
    d: "M79.81,303.708c3.748-3.159,8.721-5.657,13.742-5.127-4.915.9-9.181,3.135-13.742,5.127Z",
    transform: "translate(-79.81 -298.509)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21655",
    "data-name": "Group 21655",
    transform: "translate(93.362 325.82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50713",
    "data-name": "Path 50713",
    d: "M79.81,307.35C84.937,303.5,93.2,301,98.573,305.664c-6.011-3.276-12.929-.837-18.763,1.685Z",
    transform: "translate(-79.81 -303.128)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21656",
    "data-name": "Group 21656",
    transform: "translate(28.729 323.946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50714",
    "data-name": "Path 50714",
    d: "M24.97,303.237a39.961,39.961,0,0,1,27.92,1.827l-.354.86a21.125,21.125,0,0,0-16.983.919,19.218,19.218,0,0,1,8.391-2.911,19.636,19.636,0,0,1,8.91,1.12l-.354.86a46.531,46.531,0,0,0-27.531-2.675Z",
    transform: "translate(-24.97 -301.538)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21657",
    "data-name": "Group 21657",
    transform: "translate(42.931 330.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50715",
    "data-name": "Path 50715",
    d: "M49.772,308.789c-4-1.5-8.3-1.061-11.42,1.839-.448.389-.86.825-1.332,1.226a14.366,14.366,0,0,1,.966-1.567,8.357,8.357,0,0,1,11.786-1.5Z",
    transform: "translate(-37.02 -307.014)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21658",
    "data-name": "Group 21658",
    transform: "translate(37.757 337.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50716",
    "data-name": "Path 50716",
    d: "M48.576,313.88a15.55,15.55,0,0,0-12.516,2.239,28.832,28.832,0,0,0-3.43,2.817c.412-.625.849-1.249,1.32-1.85,3.394-4.16,9.841-5.81,14.626-3.206Z",
    transform: "translate(-32.63 -312.628)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21659",
    "data-name": "Group 21659",
    transform: "translate(52.866 348.616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50717",
    "data-name": "Path 50717",
    d: "M49.457,328.115a11.782,11.782,0,0,1-4.007-5.645,11.782,11.782,0,0,1,4.007,5.645Z",
    transform: "translate(-45.45 -322.47)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21660",
    "data-name": "Group 21660",
    transform: "translate(83.91 265.88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50718",
    "data-name": "Path 50718",
    d: "M71.79,252.27c1.367,2.569-.66,5.881,1.308,8.25-2.44-2.086-.471-5.6-1.308-8.25Z",
    transform: "translate(-71.79 -252.27)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21661",
    "data-name": "Group 21661",
    transform: "translate(99.361 269.581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50719",
    "data-name": "Path 50719",
    d: "M84.9,255.41c1.4,1.131,2.546,2.711,4.078,3.618a8.409,8.409,0,0,0,3.913.86c.448-.012.943.106,1.32-.177-.33.365-.884.295-1.308.365a7.459,7.459,0,0,1-4.1-.719c-1.615-1-2.664-2.558-3.9-3.948Z",
    transform: "translate(-84.9 -255.41)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50720",
    "data-name": "Path 50720",
    d: "M96.459,242.893a10.108,10.108,0,0,0-6.187-.554c-5.575,1.332-7.5,7.213-7.6,7.578,0,0,4.2-6.011,7.425-6.706S95.528,242.174,96.459,242.893Z",
    transform: "translate(14.062 11.791)",
    fill: "#9b5843"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21662",
    "data-name": "Group 21662",
    transform: "translate(96.685 252.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50721",
    "data-name": "Path 50721",
    d: "M101.133,244.755c-6.011-5.351-11.35-3.63-18.5-2.723,1.6-.377,3.206-.731,4.832-1.049,5.233-1.179,9.947-.306,13.671,3.771Z",
    transform: "translate(-82.63 -240.5)",
    fill: "#362513"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50722",
    "data-name": "Path 50722",
    d: "M76.67,250.94s3.135,15.64,4.962,17.16c0,0,2.923,6.6,4.349,7.507,0,0,.825,3.029-2.829,4.349,0,0,1.815-2.864.955-3.712s-4.8-7.036-5.162-9.971C78.6,263.327,76.67,250.94,76.67,250.94Z",
    transform: "translate(12.991 13.373)",
    fill: "#9b5843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50723",
    "data-name": "Path 50723",
    d: "M48.924,246.18a10.078,10.078,0,0,1,1.014,3.83,10.183,10.183,0,0,1-.86,4.714c-1.084,2.852-2.475,6.2-4.219,9.888a63.564,63.564,0,0,0-3.889,9.264c-.507,1.65-2.3,7.955,1.179,10.654,0,0-2.216-3.382,1.308-10.984A127.439,127.439,0,0,0,49.1,259l1.732-5.551S51.54,250.47,48.924,246.18Z",
    transform: "translate(6.453 12.523)",
    fill: "#9b5843"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21665",
    "data-name": "Group 21665",
    transform: "translate(5.9 176.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50724",
    "data-name": "Path 50724",
    d: "M23.081,248.08c-2.817,2.357-5.728,4.915-8.686,7.7s-5.681,5.492-8.215,8.144a16.8,16.8,0,0,1,3.63-9.664C14.666,248.257,22.008,248.092,23.081,248.08Z",
    transform: "translate(-5.496 -163.188)",
    fill: "#601a16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50725",
    "data-name": "Path 50725",
    d: "M44.1,222.109,22.7,252.162s-9.358,2.77-13.341,7.036a19.492,19.492,0,0,0-3.76,9.051s10.277-30.831,25.056-46.329C30.656,221.92,40.7,222.568,44.1,222.109Z",
    transform: "translate(-5.6 -167.859)",
    fill: "#e4262b",
    stroke: "#1d1d1b",
    strokeWidth: 1.263
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50726",
    "data-name": "Path 50726",
    d: "M27.19,230.3a83.887,83.887,0,0,1,3.123-17.549c3.029-10.419,6.718-23.1,18.138-29.865A33.627,33.627,0,0,1,63.843,178.5a34.512,34.512,0,0,1,17.478,4s12.988,7.071,15.9,20.9a141.7,141.7,0,0,1,3.17,22.511Z",
    transform: "translate(-1.745 -175.617)",
    fill: "#e4262b",
    stroke: "#1d1d1b",
    strokeWidth: 1.263
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1513",
    "data-name": "Ellipse 1513",
    cx: 3.63,
    cy: 1.438,
    rx: 3.63,
    ry: 1.438,
    transform: "translate(58.775)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1514",
    "data-name": "Ellipse 1514",
    cx: 0.978,
    cy: 0.978,
    r: 0.978,
    transform: "translate(57.09 9.205)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1515",
    "data-name": "Ellipse 1515",
    cx: 0.978,
    cy: 0.978,
    r: 0.978,
    transform: "translate(67.001 9.205)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50727",
    "data-name": "Path 50727",
    d: "M68.5,182.012a.672.672,0,1,0,.672-.672A.664.664,0,0,0,68.5,182.012Z",
    transform: "translate(5.632 -175.105)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1516",
    "data-name": "Ellipse 1516",
    cx: 0.907,
    cy: 0.907,
    r: 0.907,
    transform: "translate(48.628 7.39)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21663",
    "data-name": "Group 21663",
    transform: "translate(34.512 1.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50728",
    "data-name": "Path 50728",
    d: "M35.351,229.712l-.306-.908-.13-.955c-.236-4.467.884-8.886,1.815-13.223a61.249,61.249,0,0,1,13.459-27.354,39.36,39.36,0,0,1,12.269-9.57l.306-.141.342.118c10.855,3.76,20.224,12.08,23.913,23.065,1.025,3.489,1.862,7.425,2.557,10.972.837,4.891,2.051,9.794,2.121,14.767-.471-4.926-1.933-9.747-3.064-14.567l-1.815-7.225-1.1-3.489a35.354,35.354,0,0,0-10.584-14.555,40.318,40.318,0,0,0-12.587-7.071l.648-.024c-10.065,4.938-17.089,14.7-21.78,24.656a98.942,98.942,0,0,0-5.634,18.02c-.436,2.44-1.108,5.044-.436,7.484Z",
    transform: "translate(-34.883 -177.56)",
    fill: "#1d1d1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21664",
    "data-name": "Group 21664",
    transform: "translate(61.92 2.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50729",
    "data-name": "Path 50729",
    d: "M58.671,178.48a412.059,412.059,0,0,1,.507,50.325,414.461,414.461,0,0,1-.507-50.325Z",
    transform: "translate(-58.139 -178.48)",
    fill: "#1d1d1b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21666",
    "data-name": "Group 21666",
    transform: "translate(17.676 269.581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50730",
    "data-name": "Path 50730",
    d: "M29.321,262.053a124.8,124.8,0,0,1,33.86,1.615,23.763,23.763,0,0,0,12.328-1.19c12.917-4.443,26.353-5.916,39.883-6.753,1.226-.071,2.463.035,3.689.059,1.874.035,2.946.825,3.052,2.864.153,3.017.9,5.928-1.839,8.545-1.037.99-.813,3.43-.9,5.221-.094,1.968-.365,3.807-2.487,4.455-9.051,2.793-18.126,5.586-27.743,5.292-6.435-.2-11.42-2.581-13.506-9.287a5.48,5.48,0,0,0-6.14-4.184c-2.935.189-4.761,1.414-5.692,4.29-3.041,9.37-7.59,12.929-17.455,12.87-6.989-.035-13.99-.742-20.967-1.379-3.866-.354-4.549-1.143-5.056-5.056-.306-2.428-1.862-3.866-2.97-5.9a14.828,14.828,0,0,1-1.579-7.979c.035-.837,2.758-1.968,4.384-2.263C23.169,262.736,26.222,262.335,29.321,262.053Z",
    transform: "translate(-15.557 -255.358)",
    fill: "#e4262b",
    stroke: "#1d1d1b",
    strokeWidth: 3.367,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50731",
    "data-name": "Path 50731",
    d: "M29.131,261.763a124.8,124.8,0,0,1,33.86,1.615,23.763,23.763,0,0,0,12.328-1.19c12.917-4.443,26.353-5.916,39.883-6.753,1.226-.071,2.463.035,3.689.059,1.874.035,2.946.825,3.052,2.864.153,3.017.9,5.928-1.839,8.545-1.037.99-.813,3.43-.9,5.221-.094,1.968-.365,3.807-2.487,4.455-9.051,2.793-18.126,5.586-27.743,5.292-6.435-.2-11.42-2.581-13.506-9.287a5.48,5.48,0,0,0-6.14-4.184c-2.935.189-4.761,1.414-5.692,4.29-3.041,9.37-7.59,12.929-17.455,12.87-6.989-.035-13.99-.742-20.967-1.379-3.866-.354-4.549-1.143-5.056-5.056-.306-2.428-1.862-3.866-2.97-5.9a14.828,14.828,0,0,1-1.579-7.979c.035-.837,2.758-1.968,4.384-2.263C22.968,262.458,26.032,262.045,29.131,261.763Z",
    transform: "translate(-15.591 -255.41)",
    fill: "none",
    stroke: "#1d1d1b",
    strokeWidth: 3.367,
    opacity: 0.96
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamel);
export default __webpack_public_path__ + "static/media/camel.8aa7f8d1b59d0cd6665fe4a4fef5b685.svg";
export { ForwardRef as ReactComponent };